import { render, staticRenderFns } from "./MultiVarBarChart.vue?vue&type=template&id=3f4f7620&scoped=true"
import script from "./MultiVarBarChart.vue?vue&type=script&lang=js"
export * from "./MultiVarBarChart.vue?vue&type=script&lang=js"
import style0 from "./MultiVarBarChart.vue?vue&type=style&index=0&id=3f4f7620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f7620",
  null
  
)

export default component.exports